import React, { useContext } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useKeycloak } from "@react-keycloak/web";
import "../css/ProfileDialog.css";
import { useFormData } from "../../helper/FormDataProvider";
import { StorageContext } from "../../services/StorageProvider";
import { renderAirportCode } from "../../utils/Utils";

const ProfileDialog = ({ open, onClose }) => {
  const { keycloak } = useKeycloak();
  const { userData } = useFormData();
  const { airportData } = useContext(StorageContext);

  const getAirportAccess = () => {
    if (!userData?.data?.associations || !airportData) return "N/A";

    return userData.data.associations
      .map((association) => {
        const airport = airportData.find((a) => a.id === association.airportId);
        return airport
          ? (
            <>
              {airport.name} - {renderAirportCode(airport.iataCode, airport.icaoCode)}
            </>
          )
          : null;
      })
      .filter(Boolean)
      .map((airport, index) => (
        <div key={index} className="airport-item">
          {airport}
        </div>
      ));
  };

  const profileData = [
    { title: "Name", value: keycloak.tokenParsed?.name || "N/A" },
    { title: "Email", value: keycloak.tokenParsed?.email || "N/A" },
    { title: "Airport Access", value: getAirportAccess() },
  ];

  return (
    <Dialog open={open} onClose={onClose} className="profile-dialog">
      <div className="profile-dialog-header">
        <IconButton
          aria-label="close"
          onClick={onClose}
          className="profile-dialog-close-button"
        >
          <CloseIcon />
        </IconButton>
      </div>
      <DialogTitle className="profile-dialog-title">Profile</DialogTitle>
      <DialogContent>
        {profileData.map((item, index) => (
          <div key={index} className="profile-item">
            <span className="profile-title">{item.title}</span>
            <div className="profile-value-container">
              <span className="profile-value">{item.value}</span>
            </div>
          </div>
        ))}
      </DialogContent>
    </Dialog>
  );
};

export default ProfileDialog;
